import { render, staticRenderFns } from "./trabajadorDetalles.vue?vue&type=template&id=397c6853&"
import script from "./trabajadorDetalles.vue?vue&type=script&lang=js&"
export * from "./trabajadorDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports